const seo = (data: { title: string; metaDescription: string }): void => {
  document.title = data.title;
  document.querySelector('meta[name="description"]')!.setAttribute("content", data.metaDescription);
};

export default seo;
